export default __webpack_public_path__ + "static/media/wizard_horns.0281228f.svg";